import { GothicFrame } from '../chrome/GothicChrome';
import { ContextPanel } from '../event/ContextPanel';
import { CharacterPanel } from '../hud/CharacterPanel';
import { DungeonMap } from '../map/DungeonMap';

/** React-owned exploration HUD laid over the Phaser atmosphere. */
export function ExplorationLayout() {
  return (
    <div className="exploration-layout ui-overlay">
      <CharacterPanel />

      <div className="exploration-scene-space" aria-hidden="true">
        <span className="scene-reticle" />
      </div>

      <aside className="exploration-rail gothic-panel">
        <GothicFrame />
        <DungeonMap />
        <ContextPanel />
      </aside>
    </div>
  );
}
